const axios = require('axios')

export const getApplist = payload =>
  axios.put(`/pricing/v1/admin/messaging/accounts`, payload)
